<template>
  <!--<el-card shadow="never" class="aui-card&#45;&#45;fill">-->
  <div class="pkg-search-box">
    <el-form class="pkg-content"
             :model="dataForm"
             :rules="dataRule"
             ref="dataForm">
      <div class="location-layout">
        <el-row :gutter="0">
          <!--车辆底盘号-->
          <el-col :span="6">
            <el-form-item :label="$t('res.vehinfo.chassisNo')"
                          prop="chassisNo">
              <el-input maxlength="50"
                        :disabled="operationType === 'update'"
                        v-model.trim="dataForm.chassisNo"
                        :placeholder="$t('res.vehinfo.inputChassisNo')"></el-input>
            </el-form-item>
          </el-col>
          <!--车型分类-->
          <el-col :span="6">
            <el-form-item :label="$t('res.vehinfo.vehicleClassId')"
                          prop="vehicleClassId">
              <class-tree ref="vehicleClassRef"
                          v-on:getSelectList="getSelectList"
                          v-bind:defaultProps="defaultProps"
                          v-bind:url="queryTreeUrl"
                          v-bind:showArray="dataForm.showVehicleClassList"
                          v-bind:showValue="dataForm.showValue"
                          v-bind:isSelect=true
                          v-bind:filterText="'10'"
                          v-bind:status="'classStatus'"></class-tree>
            </el-form-item>
          </el-col>
          <!--研发代码:disabled="true"-->
          <el-col :span="6">
            <el-form-item :label="$t('res.vehinfo.rdCodeId')"
                          prop="rdCodeId">
              <el-input disabled
                        v-model="dataForm.rdCodeName"
                        :placeholder="$t('res.vehinfo.rdCodeId')"></el-input>
            </el-form-item>
          </el-col>
          <!--</el-row>-->
          <!--<el-row :gutter="0">-->
          <!--品牌:disabled="true"-->
          <el-col :span="6">
            <el-form-item :label="$t('res.vehinfo.brandId')"
                          prop="brandId">
              <el-input disabled
                        v-model="dataForm.brandName"
                        :placeholder="$t('res.vehinfo.brandId')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <br/>
        <el-row :gutter="0">
          <!--所属公司-->
          <el-col :span="6">
            <el-form-item :label="$t('res.vehinfo.companyId')"
                          prop="companyId">
              <el-select clearable
                         filterable
                         collapse-tags
                         v-model="dataForm.companyId">
                <el-option v-for="item in companyList"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--所属场地-->
          <el-col :span="6">
            <el-form-item :label="$t('res.vehinfo.subordinateSiteId')"
                          prop="subordinateSiteId">
              <el-input v-model="dataForm.subordinateSiteName"
                        @focus="showSuboSiteDlg()"
                        readonly
                        :placeholder="$t('res.vehinfo.select')"></el-input>
              <el-input v-model="dataForm.subordinateSiteId"
                        v-show="false"></el-input>
            </el-form-item>
          </el-col>
          <!--</el-row>-->
          <!--<el-row :gutter="0">-->
          <!--车辆分类-->
          <el-col :span="6">
            <el-form-item :label="$t('res.vehinfo.vehicleClassification')"
                          prop="vehicleClassification">
              <el-select v-model="dataForm.vehicleClassification"
                         :placeholder="$t('res.vehinfo.select')">
                <el-option v-for="(item,index) in vehicleClassArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--车辆状态-->
          <el-col :span="6">
            <el-form-item :label="$t('res.vehinfo.status')"
                          prop="status">
              <el-select v-model="dataForm.status"
                         :disabled="true"
                         :placeholder="$t('res.vehinfo.status')">
                <el-option v-for="(item,index) in statusArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--</el-row>-->
          <!--<el-row :gutter="0">-->
        </el-row>
        <br/>
        <el-row :gutter="0">
          <!--是否计算利用率-->
          <el-col :span="6">
            <el-form-item :label="$t('res.vehinfo.ifCount')"
                          prop="ifCount">
              <el-select v-model="dataForm.ifCount"
                         :placeholder="$t('res.vehinfo.ifCount')">
                <el-option v-for="(item,index) in ifCountList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--</el-row>-->
          <!--<el-row :gutter="0">-->
          <!--发动机型号-->
          <el-col :span="6">
            <el-form-item :label="$t('res.vehinfo.engineModel')"
                          prop="engineModel">
              <el-input maxlength="50"
                        v-model="dataForm.engineModel"
                        :placeholder="$t('res.vehinfo.inputEngineModel')"></el-input>
            </el-form-item>
          </el-col>
          <!--开始时间-->
          <!--:disabled="operationType === 'update'"-->
          <el-col :span="6">
            <el-form-item :label="$t('res.vehinfo.startTime')"
                          prop="startTime">
              <el-date-picker type="date"
                              value-format="yyyy-MM-dd"
                              v-model="dataForm.startTime"
                              :placeholder="$t('res.vehinfo.startTime')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!--结束时间-->
          <!--:picker-options="checkEndTime"-->
          <el-col :span="6">
            <el-form-item  prop="endTime">
              {{$t('res.vehinfo.endTime')}}
                <el-tooltip
                        class="item"
                        effect="light"
                        content="结束日期当日可用。"
                        placement="top-start"
                ><em class="el-icon-question" style="color: #1C69D3"></em>
                </el-tooltip>
              <el-date-picker type="date"
                              :disabled="dataForm.status === '20'"
                              value-format="yyyy-MM-dd"
                              v-model="dataForm.endTime"
                              :placeholder="$t('res.vehinfo.inputEndTime')">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <br/>
        <el-row :gutter="0">
          <!--生产日期-->
          <el-col :span="6">
            <el-form-item :label="$t('res.vehinfo.productionDate')"
                          prop="productionDate">
              <el-date-picker type="date"
                              value-format="yyyy-MM-dd"
                              v-model="dataForm.productionDate"
                              :placeholder="$t('res.vehinfo.inputProductionDate')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!--备注-->
          <el-col :span="6">
            <el-form-item :label="$t('res.vehinfo.remark')"
                          prop="remark">
              <el-input maxlength="100"
                        v-model="dataForm.remark"
                        :placeholder="$t('res.vehinfo.inputRemark')"></el-input>
            </el-form-item>
          </el-col>
          <!--</el-row>-->
          <!--<el-row :gutter="0">-->
          <!--上传车辆配置详细信息文件-->
          <el-col :span="12">
            <el-form-item prop="isUpload">
              <div>&nbsp;</div>
              <div style="float :  left">
                <upload-file v-bind:fileList="fileList"
                             v-bind:beforeRemove="uploadBeforeRemove"
                             v-bind:uploadSuccess="submitUploadSuccess"></upload-file>
                <div style="text-align: left;font-size: 12px;color: darkgray;">{{'上传车辆配置信息文件(不超过4M，上传格式为jpg/png/xlsx/xls/zip/rar/txt/pdf文件)'}}</div>
              </div>
            </el-form-item>
            <el-button v-if="dataForm.fileName !== '' || dataForm.fileName"
                       size="mini"
                       @click="downloadFile"
                       type="text">{{dataForm.fileName}}</el-button>
            <!--<span v-if="dataForm.fileName !== '' || dataForm.fileName" style="font-weight: bold;">{{dataForm.fileName}}</span>-->
          </el-col>
        </el-row>
      </div>
    </el-form>
    <br>
    <br>
    <div class="pkg-content">
      <h3>{{ $t('res.cri.tag') }}</h3>
      <el-form label-position="top"
               label-width="145px"
               :ref="dataForm"
               ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName"
                            style="width: 100%!important;">
                <tag :checkedList="checkList"
                     :moduleId="moduleId"
                     :overLabelShow = "true"
                     :closeShow = "true"
                     :bussinessTypeId = "bussinessTypeId"
                     :brandCode="bussinessTypeChecked"
                     @getBussinessType="getBussinessType"
                     @changeCheckedList="changeCheckedList"
                     ref.native='tagTree'
                     @fatherMethod="fatherMethod"></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <br>
    <br>
    <div class="pkg-content">
      <el-row>
        <el-col :span="24"
                style="line-height: 34px;">
          <div>
            <div class="label-title">{{ $t('res.cri.yearTargetList') }}</div>
            <div class="button-icon">
              <!-- 新增 -->
              <el-button size="mini"
                         type="primary"
                         @click="addTarget()">{{ $t('res.rela.insert') }}</el-button>
              <div class="el-icon-arrow-up pkg-icon-button"
                   v-if="isShowYearTarget"
                   @click="isShowYearTarget = !isShowYearTarget"></div>
              <div class="el-icon-arrow-down pkg-icon-button"
                   v-else
                   @click="isShowYearTarget = !isShowYearTarget"></div>
            </div>
          </div>
        </el-col>
      </el-row>
      <br>
      <el-row v-show="isShowYearTarget">
        <el-col :span="24">
          <el-table :data="targetTableData"
                    height="250"
                    border
                    stripe
                    style="width: 100%">
            <!-- 年份 -->
            <el-table-column prop="annual"
                             align="center"
                             :label="$t('res.cri.year')"
                             min-width="180">
              <template slot-scope="scope">
                <el-input v-if="scope.row.isEdit || scope.row.isAdd"
                          size="mini"
                          v-model="scope.row.annual"
                          maxlength="4"></el-input>
                <span v-else>{{scope.row.annual}}</span>
              </template>
            </el-table-column>
            <!-- 报表年度目标 -->
            <el-table-column prop="reportAnnualTarget"
                             align="center"
                             :label="$t('res.cri.yearTarget')"
                             min-width="180">
              <template slot-scope="scope">
                <el-input v-if="scope.row.isEdit || scope.row.isAdd"
                          size="mini"
                          v-model="scope.row.reportAnnualTarget"
                          maxlength="10"></el-input>
                <span v-else>{{scope.row.reportAnnualTarget}}</span>
              </template>
            </el-table-column>
            <!-- 操作 -->
            <el-table-column prop="operation"
                             align="center"
                             :label="$t('res.cri.operation')"
                             width="250">
              <template slot-scope="scope">
                <!--修改按钮-->
                <el-button type="primary"
                           v-if="scope.row.isEdit || ((new Date(String(new Date().getFullYear())).getTime() <= new Date(scope.row.annual).getTime()) && !scope.row.isAdd)"
                           size="mini"
                           @click="editTarget(scope.row, scope.$index)">{{ $t('res.cri.edit') }}</el-button>
                <template v-if="isAddForm">
                  <!-- 清除（配合新增使用） -->
                  <el-button type="primary"
                             v-if="scope.row.isAdd"
                             @click="deleteTarget(scope.$index)">{{ $t('delete') }}</el-button>
                </template>
                <!--删除按钮（配合编辑使用）-->
                <el-button type="primary"
                           v-if="scope.row.isEdit || ((new Date(String(new Date().getFullYear())).getTime() <= new Date(scope.row.annual).getTime()) && !scope.row.isAdd)"
                           size="mini"
                           @click="targetDelete(scope.$index)">{{ $t('delete') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <br>
    <div class="pkg-content">
      <div class="btn-position-up"
           style="text-align:right;">
        <!--保存按钮-->
        <el-button :loading="dataListLoading"
                   type="primary"
                   @click="dataFormSubmitHandle()">{{ $t('res.vehinfo.save') }}</el-button>
        <!--返回按钮-->
        <el-button type="info" @click="backPage()">{{ $t('res.vehinfo.back') }}</el-button>
      </div>
    </div>
    <!--所属场地-->
    <subordinate-site ref="suborSiteRef"
                      :isSingleElection='true'
                      :isShow='false'
                      :isQueryShow="true"
                      v-bind:selectTable="selectTable"
                      v-bind:statusList="statusList"
                      :dialogVisible="isShowSuboSite"
                      v-on:closeSuboSiteDlg="closeSuboSiteDlg"
                      v-on:bringBack="bringBack"></subordinate-site>
  </div>
  <!--</el-card>-->
</template>

<script>
import ClassTree from '@/components/rm/class-tree/index'
import { getUUID } from '@/utils/index'
import subordinateSite from '@/components/rm/resources-site/index'
import UploadFile from '@/components/rm/upload-file/index'
import Tag from '@/components/rm/label/index'
import VueI18n from '@/i18n'

export default {
  components: {
    Tag,
    'class-tree': ClassTree,
    'subordinate-site': subordinateSite,
    'upload-file': UploadFile
  },
  data () {
    let _this = this
    return {
      statusArr: _this.enums['status'], // 状态
      ifCountList: _this.enums['confirmState'], // 是否利用计算率
      vehicleClassArr: _this.enums['vehicleClass'], // 车辆分类
      dataListLoading: false,
      visible: false,
      // 是否显示所属场地
      isShowSuboSite: false,
      selectTable: [],
      statusList:['10'],
      // 车型分类树
      defaultProps: {
        children: 'children',
        label: 'classCnName'
      },
      queryTreeUrl: '/rm/vehicleclass/list',
      // 操作类型 新增/修改
      operationType: '',
      // 校验结束时间
      checkEndTime: this.checkSiteInfoEndTime(),
      checkList: [],
      checkeList: [],
      // 模块id，20 代表组织管理模块
      moduleId: '20',
      bussinessTypeId: [],
      bussinessTypeChecked: [],
      companyList: [],
      dataForm: {
        showVehicleClassList: [],
        showValue: '',
        id: 0,
        chassisNo: '',
        vehicleClassId: '',
        rdCodeId: '',
        rdCodeName: '',
        brandId: '',
        brandName: '',
        companyId: '',
        subordinateSiteId: '',
        subordinateSiteName: '',
        presentSiteId: '',
        presentSiteName: '',
        addPresentSiteId: '',
        addPresentSiteName: '',
        vehicleClassification: '',
        status: '10',
        productionDate: '',
        labelId:'',
        startTime: new Date(),
        endTime: '',
        ifCount: '10',
        engineModel: '',
        isUpload: '',
        creator: '',
        createdDate: '',
        modifier: '',
        lastUpdatedDate: '',
        remark: '',
        version: '',
        // 文件上传信息
        fileUpload: undefined,
        // 文件名称
        fileName: '',
        // 文件id
        fileId: ''
      },
      // 年度目标列表数据
      targetTableData: [],
      // 保存和编辑按钮的切换开关
      saveBtn: false,
      dataRule: {
        chassisNo: [
          { required: true, message: this.$t('res.vehinfo.chassisNo') + this.$t('res.site.notNull'), trigger: 'blur' }
        ],
        vehicleClassId: [
          { required: true, message: this.$t('res.vehinfo.vehicleClassId') + this.$t('res.site.notNull'), trigger: 'change' }
        ],
        companyId: [
          { required: true, message: this.$t('res.vehinfo.companyId') + this.$t('res.site.notNull'), trigger: 'change' }
        ],
        subordinateSiteId: [
          { required: true, message: this.$t('res.vehinfo.subordinateSiteId') + this.$t('res.site.notNull'), trigger: 'change' }
        ],
        presentSiteId: [
          { required: true, message: this.$t('res.vehinfo.presentSiteId') + this.$t('res.site.notNull'), trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: this.$t('res.vehinfo.startTime') + this.$t('res.site.notNull'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('res.rela.status') + this.$t('res.site.notNull'), trigger: 'change' }
        ],
        ifCount: [
          { required: true, message: this.$t('res.vehinfo.ifCount') + this.$t('res.site.notNull'), trigger: 'change' }
        ]
        // engineModel: [
        //   { required: true, message: this.$t('res.vehinfo.engineModel') + this.$t('res.site.notNull'), trigger: 'blur' }
        // ]
      },
      //  类型（新增或删除）
      type: '',
      isAddForm: false,
      // 上传的文件
      fileList: [],
      // 是否显示年度目标
      isShowYearTarget: true
    }
  },
  mounted () {
    this.initMethod()
    // this.$eventHub.$on(this.GLOBAL.VEHICLE_INFO, (data) => {
    //   this.initMethod()
    // })
  },
  methods: {
    // 页面打开初始化方法
    initMethod () {
      // 清空车型分类
      this.$refs.vehicleClassRef && this.$refs.vehicleClassRef.resetChecked()
      // 清空所属场地
      this.dataForm.subordinateSiteName = ''
      // 清空表单校验
      this.$nextTick(() => {
        this.$refs['dataForm'] && this.$refs['dataForm'].resetFields()
      })
      // 清空年度目标table
      this.targetTableData = []
      // 清空文件上传信息
      this.fileList = []
      this.dataForm.fileUpload = undefined
      this.dataForm.fileName = ''
      this.dataForm.fileId = ''
      this.queryCompany()
      this.operationType = this.$route.query.operationType
      if (this.$route.query.id !== undefined) {
        this.dataForm.id = this.$route.query.id
        this.type = this.$route.query.type
        // this.operationType = this.$route.query.operationType

        this.getInfo()
      }
    },
    // 查询公司下拉选
    queryCompany () {
      // 获取公司下拉框数据
      this.$request.get(`/rm/company/queryCommonOrgState`, { 'orgTypeList': '10,20,30,40,50,60' }).then((data) => {
        let arr = []
        data.forEach(function (item) {
          let param = { value: item.orgId, label: item.nameCn }
          arr.push(param)
        })
        this.companyList = arr
      })
    },
    // 获取信息
    getInfo () {
      this.$request.get(`/rm/vehicleinfo/info/${this.dataForm.id}`).then((data) => {
        console.info('data------------->', data)
        this.dataForm.chassisNo = data.chassisNo
        this.dataForm.vehicleClassId = data.vehicleClassId
        this.dataForm.rdCodeId = data.rdCodeId
        this.dataForm.rdCodeName = data.rdCodeName
        this.dataForm.brandId = data.brandId
        this.dataForm.brandName = data.brandName
        this.dataForm.companyId = data.companyId
        this.dataForm.subordinateSiteId = data.subordinateSiteId
        this.dataForm.subordinateSiteName = data.siteCnName
        this.dataForm.presentSiteId = data.presentSiteId
        this.dataForm.presentSiteName = data.presentSiteName
        this.dataForm.vehicleClassification = data.vehicleClassification
        this.dataForm.status = data.status
        this.dataForm.fileName = data.fileName
        this.dataForm.fileId = data.fileId
        this.selectTable = [{
          id: this.dataForm.subordinateSiteId,
          siteCnName: this.dataForm.subordinateSiteName
        }]
        if (data.startTime) {
          this.dataForm.startTime = data.startTime.substring(0, 10)
        } else {
          this.dataForm.startTime = data.startTime
        }
        if (data.productionDate) {
          this.dataForm.productionDate = data.productionDate.substring(0, 10)
        } else {
          this.dataForm.productionDate = data.productionDate
        }
        if (data.endTime) {
          this.dataForm.endTime = data.endTime.substring(0, 10)
        } else {
          this.dataForm.endTime = data.endTime
        }
        this.dataForm.ifCount = data.ifCount
        this.dataForm.engineModel = data.engineModel
        this.dataForm.isUpload = data.isUpload
        this.dataForm.creator = data.creator
        this.dataForm.createdDate = data.createdDate
        this.dataForm.modifier = data.modifier
        this.dataForm.remark = data.remark
        this.dataForm.lastUpdatedDate = data.lastUpdatedDate
        this.dataForm.version = data.version
        this.targetTableData = data.targetList
        // 车型分类的回填
        this.dataForm.showValue = data.classCnName
        this.dataForm.showVehicleClassList = []
        this.dataForm.showVehicleClassList.push(data.vehicleClassId)
        this.bussinessTypeId = data.bussinessTypeId
        this.bussinessTypeChecked = data.bussinessTypeId
        // this.$refs.tagTree.getDealer()
        // this.$emit('getDealer')
        debugger
        // 已选择的标签
        this.checkList = data.commLabelVoList ? data.commLabelVoList : []
        this.checkeList = data.commLabelVoList ? data.commLabelVoList : []
        // 特殊情况，自己国际化
        const language = VueI18n.locale
        if (language === 'zh-CN') {
          // this.checkList.forEach((o,i) => {
          //   console.info('o.labelNameCn------------>', o.labelNameCn)
          //   if(o.labelNameCn !== null){
          //     o.labelName = o.labelNameCn
          //   }else{
          //     var index=this.checkList.indexOf(o)
          //     this.checkList.splice(index,1)
          //   }
          // })
          for(let i = 0; i < this.checkList.length; i ++){
            if(this.checkList[i].labelNameCn !== null){
              this.checkList[i].labelName = this.checkList[i].labelNameCn
            }else{
              this.checkList.splice(i,1)
              i--
            }
          }
        } else {
          // this.checkList.forEach(o => {
          //   if(o.labelNameCn !== null){
          //     o.labelName = o.labelNameEn
          //   }else{
          //     var index=this.checkList.indexOf(o)
          //     this.checkList.splice(index,1)
          //   }
          // })
          for(let i = 0; i < this.checkList.length; i ++){
            if(this.checkList[i].labelNameEn !== null){
              this.checkList[i].labelName = this.checkList[i].labelNameEn
            }else{
              this.checkList.splice(i,1)
              i--
            }
          }
        }
        // 标签组件的查询
        // this.$emit('getDealer')
      })
    },
    // 年度目标校验正整数的正则表达式
    isPositiveInteger (s) {
      let re = /^\+?[0-9][0-9]*$/
      return re.test(s)
    },
    // 表单提交
    dataFormSubmitHandle () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          // 控制保存按钮，防止重复点击保存
          this.dataListLoading = true
          console.info('this.dataForm-------------------->', this.dataForm)
          if(this.dataForm.endTime === ''){
              this.dataForm.endTime = ''
            }
          // debugger
          // if(this.dataForm.endTime === ''){
          //   this.dataForm.endTime = ''
          // }else{
          //   if(this.dataForm.startTime > this.dataForm.endTime){
          //     this.$message.warning(this.$t('res.cri.r.checkSiteInfoEndTime'))
          //     this.dataListLoading = false
          //     return false
          //   }
          // }
          let annualMap = new Map()
          for (let j = 0; j < this.targetTableData.length; j++) {
            let itemJ = this.targetTableData[j]
            // 校验年份是否为空
            if (itemJ.annual === null || itemJ.annual === '') {
              this.$message.warning(this.$t('res.cri.r.annual'))
              this.dataListLoading = false
              return false
            }
            // 校验只能输入当前及以后的年份
            if ((itemJ.isAdd || itemJ.isEdit) && itemJ.annual < new Date().getFullYear()) {
              this.$message.warning(this.$t('res.cri.r.annualCheck'))
              this.dataListLoading = false
              return false
            }
            // 校验年份是否重复
            if (annualMap.get(String(itemJ.annual))) {
              this.dataListLoading = false
              this.$message.warning(this.$t('res.cri.r.yearCheck'))
              return false
            } else {
              annualMap.set(String(itemJ.annual), 'A')
            }
            // 校验年份只能为正整数
            if (!this.isPositiveInteger(itemJ.annual)) {
              this.$message.warning(this.$t('res.cri.r.reportAnnualCheck'))
              this.dataListLoading = false
              return false
            }
            // 校验目标值是否为空
            if (itemJ.reportAnnualTarget === null || itemJ.reportAnnualTarget === '') {
              this.$message.warning(this.$t('res.cri.r.reportAnnualTarget'))
              this.dataListLoading = false
              return false
            }
            // 校验报表年度目标值只能为正整数
            if (!this.isPositiveInteger(itemJ.reportAnnualTarget)) {
              console.info(itemJ.reportAnnualTarget)
              this.$message.warning(this.$t('res.cri.r.reportAnnualTargetCheck'))
              this.dataListLoading = false
              return false
            }
          }
          // 遍历年度目标数据集，是新增则清空ID
          let bakTargetTableData = [...this.targetTableData]
          for (let i = 0; i < bakTargetTableData.length; i++) {
            let item = bakTargetTableData[i]
            if (String(item.id).indexOf('keyId-') <= 0) {
              item.id = ''
            }
          }
          console.info(this.dataForm)
          let tmp = []
          this.dataForm.labelId = ''
          if (this.checkList.length !== 0) {
            this.checkList.forEach(o => {
              tmp.push(o.labelId)
            })
            this.dataForm.labelId = tmp.join(',')
          }
          this.$request.post(
            `/rm/vehicleinfo/${!this.dataForm.id ? 'save' : 'update'}`,
            {
              'id': this.dataForm.id,
              'chassisNo': this.dataForm.chassisNo,
              'vehicleClassId': this.dataForm.vehicleClassId,
              'rdCodeId': this.dataForm.rdCodeId,
              'brandId': this.dataForm.brandId,
              'companyId': this.dataForm.companyId,
              'subordinateSiteId': this.dataForm.subordinateSiteId,
              'presentSiteId': this.dataForm.subordinateSiteId,
              'presentSiteName': this.dataForm.subordinateSiteName,
              'vehicleClassification': this.dataForm.vehicleClassification,
              'status': this.dataForm.status,
              'productionDate': this.dataForm.productionDate,
              'startTime': this.dataForm.startTime,
              'endTime': this.dataForm.endTime,
              'ifCount': this.dataForm.ifCount,
              'engineModel': this.dataForm.engineModel,
              'isUpload': this.dataForm.isUpload,
              'remark': this.dataForm.remark,
              'version': this.dataForm.version,
              'addPresentSiteId': this.dataForm.subordinateSiteId,
              'addPresentSiteName': this.dataForm.subordinateSiteName,
              'targetTableData': bakTargetTableData,
              'fileUpload': this.dataForm.fileUpload,
              'fileId': this.dataForm.fileId,
              'labelId' : this.dataForm.labelId
            }
          ).then((data) => {
            console.info(data)
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.yearAry = []
                this.dataListLoading = false
                if (this.operationType === 'add' && data) {
                  this.dataForm.id = data.id
                }
                this.operationType = 'update'
                this.type = 'update'
                // 保存成功后清除文件
                this.fileList = []
                this.dataForm = {
                  showVehicleClassList: [],
                  showValue: '',
                  id: 0,
                  chassisNo: '',
                  vehicleClassId: '',
                  rdCodeId: '',
                  rdCodeName: '',
                  brandId: '',
                  brandName: '',
                  companyId: '',
                  subordinateSiteId: '',
                  subordinateSiteName: '',
                  presentSiteId: '',
                  presentSiteName: '',
                  addPresentSiteId: '',
                  addPresentSiteName: '',
                  vehicleClassification: '',
                  status: '10',
                  productionDate: '',
                  labelId:'',
                  startTime: new Date(),
                  endTime: '',
                  ifCount: '10',
                  engineModel: '',
                  isUpload: '',
                  creator: '',
                  createdDate: '',
                  modifier: '',
                  lastUpdatedDate: '',
                  remark: '',
                  version: '',
                  // 文件上传信息
                  fileUpload: undefined,
                  // 文件名称
                  fileName: '',
                  // 文件id
                  fileId: ''
                }
                this.tabRemove()
                // this.getInfo()
              }
            })
          }).catch((error) => {
            this.yearAry = []
            this.dataListLoading = false
            console.error(error)
          })
        }
      })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    },
    // 删除按钮
    targetDelete (index) {
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.targetTableData.splice(index, 1)
      }).catch((err) => {
        console.log(err)
      })
    },
    backPage () {
      this.$router.go(-1)
    },
    // 车型分类树
    getSelectList (args) {
      console.info('args----------->', args)
      // 判断车型分类返回数组的长度
      if (args && args !== '' && args.length > 0) {
        console.info(args.length)
        this.dataForm.vehicleClassId = args[0].id
        // 查询研发代码和品牌
        this.$request.post(
          '/rm/vehicleclass/queryClassBrandAndRd', { 'id' : args[0].id ,'levelPid': args[0].levelPid }
        ).then((res) => {
          let vce = res.vce
          // 研发代码
          let rdCode = res.rdCode
          this.dataForm.rdCodeId = rdCode.id
          this.dataForm.rdCodeName = rdCode.classCnName
          // 品牌
          let brand = res.brand
          this.dataForm.brandId = brand.id
          this.dataForm.brandName = brand.classCnName
          let bussinessTypeIds = []
          if(vce.bussinessTypeId){
            bussinessTypeIds.push(vce.bussinessTypeId)
          }
          if(rdCode.bussinessTypeId){
            bussinessTypeIds.push(rdCode.bussinessTypeId)
          }
          if(brand.bussinessTypeId){
            bussinessTypeIds.push(brand.bussinessTypeId)
          }
          this.bussinessTypeId = bussinessTypeIds
          this.bussinessTypeChecked = bussinessTypeIds
          // this.$refs.tagTree.getDealer()
          // this.$emit('getDealer')



        }).catch((error) => {
          this.$message.error(error)
        })
      } else {
        // 未选择分类 清空车型分类id和研发代码、品牌
        this.dataForm.vehicleClassId = ''
        this.dataForm.rdCodeId = ''
        this.dataForm.rdCodeName = ''
        this.dataForm.brandId = ''
        this.dataForm.brandName = ''
      }
    },
    // 年度目标新增按钮
    addTarget () {
      this.isAddForm = true
      let year = new Date().getFullYear()
      let uuid = getUUID()
      let target = { 'id': uuid, 'annual': year, 'reportAnnualTarget': '', isAdd: true }
      this.targetTableData.push(target)
    },

    // 清除年度目标
    deleteTarget (index) {
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.targetTableData.splice(index, 1)
      }).catch((err) => {
        console.log(err)
      })
    },

    // 年度目标修改按钮
    editTarget (row, index) {
      this.isAddForm = false
      row['isEdit'] = true
      this.$set(this.targetTableData, index, row)
    },
    // 关闭所属场地
    closeSuboSiteDlg () {
      this.isShowSuboSite = false
    },
    // 点击所属场地确定带回
    bringBack (selection) {
      let rowData = selection[0]
      console.info('rowData' + rowData)
      let siteId = rowData.id
      let siteCnName = rowData.siteCnName
      this.dataForm.subordinateSiteId = siteId
      this.dataForm.subordinateSiteName = siteCnName
      this.selectTable = siteId ? [{ id: siteId, siteCnName: siteCnName }] : []
      this.isShowSuboSite = false
    },
    // 点击所属场地打开弹窗
    showSuboSiteDlg () {
      this.isShowSuboSite = true
      this.$refs.suborSiteRef.initSuborSite()
    },
    // 校验结束时间
    checkSiteInfoEndTime () {
      return {
        disabledDate: function disabledDate (time) {
          return new Date().getTime() > time.getTime()
        }
      }
    },
    // 获取文件上的后的文件信息
    submitUploadSuccess (response, file, fileList) {
      if (response && response !== '') {
        this.dataForm.fileUpload = response.data
        this.dataForm.fileName = response.data.filename
        this.dataForm.fileId = response.data.fileId
      }
    },
    // 移除文件
    uploadBeforeRemove (file, fileList) {
      this.fileList = []
      this.dataForm.fileUpload = undefined
      this.dataForm.fileName = ''
      this.dataForm.fileId = ''
    },
    // 下载文件
    downloadFile () {
      let requestUrl = window.SITE_CONFIG['apiBaseURL'] + '/rm/file/download' + `?token=${this.getStorage(this.GLOBAL.TOKEN)}`
      let dlform = document.createElement('form')
      dlform.method = 'post'
      dlform.action = requestUrl
      let hdnFilePath = document.createElement('input')
      hdnFilePath.type = 'hidden'
      hdnFilePath.name = 'id'
      hdnFilePath.value = this.dataForm.fileId
      dlform.appendChild(hdnFilePath)
      document.body.appendChild(dlform)
      dlform.submit()
      document.body.removeChild(dlform)
    },
    getBussinessType (val) {
      this.dataForm.bussinessTypeId = []
      this.bussinessTypeId = []
    },
    changeCheckedList (array) {
      debugger
      this.checkList = array
    },
    // 重新勾选业务标签
    fatherMethod () {
      console.log('------------------ checkList ----------------------- 父组件1 -----------------------', this.checkList)
      debugger
      this.checkList = []
      // 已选择的标签
      // this.checkList = this.dataForm.commLabelVoList ? this.dataForm.commLabelVoList : []
      this.checkList = this.checkeList
      // 特殊情况，自己国际化
      const language = VueI18n.locale
      if (language === 'zh-CN') {
        // this.checkList.forEach((o,i) => {
        //   console.info('o.labelNameCn------------>', o.labelNameCn)
        //   if(o.labelNameCn !== null){
        //     o.labelName = o.labelNameCn
        //   }else{
        //     var index=this.checkList.indexOf(o)
        //     this.checkList.splice(index,1)
        //   }
        // })
        for(let i = 0; i < this.checkList.length; i ++){
          if(this.checkList[i].labelNameCn !== null){
            this.checkList[i].labelName = this.checkList[i].labelNameCn
          }else{
            this.checkList.splice(i,1)
            i--
          }
        }
      } else {
        // this.checkList.forEach(o => {
        //   if(o.labelNameCn !== null){
        //     o.labelName = o.labelNameEn
        //   }else{
        //     var index=this.checkList.indexOf(o)
        //     this.checkList.splice(index,1)
        //   }
        // })
        for(let i = 0; i < this.checkList.length; i ++){
          if(this.checkList[i].labelNameEn !== null){
            this.checkList[i].labelName = this.checkList[i].labelNameEn
          }else{
            this.checkList.splice(i,1)
            i--
          }
        }
      }
      // if (language === 'zh-CN') {
      //   this.checkList.forEach(o => {
      //     o.labelName = o.labelNameCn
      //   })
      // } else {
      //   this.checkList.forEach(o => {
      //     o.labelName = o.labelNameEn
      //   })
      // }
    }
  },
  updated() {
    console.log('------------------ checkList ----------------------- 父组件2 -----------------------', this.checkList)
  }
  // ,
  // mounted() {
  //   console.log('------------------ checkList ----------------------- 父组件3 -----------------------', this.checkList)
  // },
  // beforeUpdate() {
  //   console.log('------------------ checkList ----------------------- 父组件4 -----------------------', this.checkList)
  // }
}
</script>

<style lang="css" scoped>
/* 模拟部分的el-card样式 */
.pkg-search-box {
  color: #303133;
  transition: 0.3s;
  border-radius: 4px;
  overflow: hidden;
}
.pkg-content {
  background-color: #fff;
  padding: 20px;
}
/* icon style */
.pkg-icon-button {
  display: inline-block;
  padding: 0 20px;
  font-size: 20px;
  color: blue;
  vertical-align: middle;
  cursor: pointer;
}
.label-title {
  font-size: 16px;
  font-weight: bold;
  display: inline-block;
}
.button-icon {
  display: inline-block;
  float: right;
}
</style>
